import React, { FC, useState } from 'react';
import clip from 'text-clipper';
import { useTranslations } from '@lang';
import { DescriptionWrapper, ReadMoreLink } from '../BookableListItem.styles';
import { ContentParser } from '@common/components/ContentParser';

type DescriptionClipperOpts = {
  maxLength: number;
  maxLines?: number;
};

type DescriptionClipperProps = {
  description: string;
  terms?: string;
  options: DescriptionClipperOpts;
};

export const DescriptionClipper: FC<DescriptionClipperProps> = ({
  description,
  terms,
  options,
}) => {
  const { t } = useTranslations();
  const [showFullDetails, setShowFullDetails] = useState(false);
  const readLessText = t('common.readLess');
  const readMoreText = t('common.readMore');

  const clipDescription = (description) => {
    const { maxLines } = options;
    const clippedDescription = clip(description, options.maxLength, {
      maxLines,
      html: true,
      stripTags: true,
    });

    return clippedDescription;
  };

  return (
    <>
      <DescriptionWrapper>
        {showFullDetails ? (
          <>
            <ContentParser escapeHtml={false} text={description} />
            {/* TODO: move Terms out of component - pass in additional content as child */}
            {terms && <ContentParser escapeHtml={false} text={terms} />}
          </>
        ) : (
          <ContentParser escapeHtml={false} text={clipDescription(description)} />
        )}

        <p>
          <ReadMoreLink onClick={() => setShowFullDetails((s) => !s)}>
            {showFullDetails ? readLessText : readMoreText}
          </ReadMoreLink>
        </p>
      </DescriptionWrapper>
    </>
  );
};
